<template>
  <div class="main-wrapper bus-ticket">
    <div class="container">
      <div class="invoice-wrapper download_section">
        <div class="inv-content">
          <div class="invoice-header">
            <div class="inv-header-left">
              <a href="javascript:;">
                <img src="@/assets/img/logo2.png" alt="Logo" />
              </a>
            </div>
            <div class="inv-header-right">
              <h2>Dreams Bus</h2>
            </div>
          </div>
          <div class="flight-invoice-details">
            <div class="bus-booking-address">
              <div class="booked-add">
                Dreams Bus Line Pvt Ltd.
                <span>299 Star Trek Drive, Panama City, Florida, 32405, USA</span>
              </div>
              <h3>Tax Invoice</h3>
            </div>
            <div class="invoice-infomation">
              <div>Date: <span>05/12/2022</span></div>
              <div>Journey Date: <span>05/01/2023</span></div>
              <div>Invoice No: <span>#00001</span></div>
            </div>
          </div>
          <div class="passenger-ticket-details">
            <h5 class="invoice-title">Passenger & Ticket infomation</h5>
            <div class="passenger-info">
              <div class="passenger-details">
                <div>Passenger Name <span>Jennifer Richards </span></div>
                <div>Seat Number<span>SBA1, SBA2, A30</span></div>
              </div>
              <div class="payment-info me-0">
                <div>Journey Date <span>05 Feb 2022 </span></div>
                <div>Ticket Number<span>#SM75692</span></div>
              </div>
            </div>
          </div>
          <div class="invoice-table">
            <h6 class="invoice-title">Travel Information</h6>
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th class="table_width_1">#</th>
                    <th class="table_width_2">Bus Details</th>
                    <th class="text-center">Bus Fare</th>
                    <th class="text-end table_width_4">Qty</th>
                    <th class="text-end table_width_4">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td class="table-description">
                      Dreams Bus Line Pvt Ltd., - Business Seat<span
                        >Date: 25 Dec 2022, Sat 8:30AM</span
                      >
                    </td>
                    <td class="text-center">$560</td>
                    <td class="text-end">1</td>
                    <td class="text-end">$560</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td class="table-description">
                      Dreams Bus Line Pvt Ltd., - Economy Seat<span
                        >Date: 25 Dec 2022, Sat 8:30AM</span
                      >
                    </td>
                    <td class="text-center">$240</td>
                    <td class="text-end">1</td>
                    <td class="text-end">$240</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer">
            <div class="table-footer-left notes"></div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>Taxable Amount</td>
                    <td>₹800</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer">
            <div class="table-footer-left notes">
              <span></span>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>IGST 18.0%</td>
                    <td>$144</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer totalamount-footer">
            <div class="table-footer-left">
              <span class="total-item">Total Items / Qty : 2 / 2.00</span>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td class="invoice-title">Total</td>
                    <td class="invoice-title">$944</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer payable-table">
            <div class="table-footer-left notes">
              Total amount ( in words):
              <span>USD Nine Hundred Forty-Four Dollars Only.</span>
            </div>
            <div class="text-end table-footer-right amount-payable">
              <table>
                <tbody>
                  <tr>
                    <td class="invoice-title">Amount Payable</td>
                    <td class="invoice-title">$944</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="bank-details">
            <div class="payment-info">
              <span class="payment-title">Payment Info:</span>
              <div><span>Debit Card :</span> 465 *************645</div>
              <div><span>Amount :</span> $1,815</div>
            </div>
            <div class="company-sign">
              <span>For Dreamguys</span>
              <img src="@/assets/img/signature.png" alt="" />
            </div>
          </div>
          <div class="terms-condition">
            <span>Terms and Conditions:</span>
            <p>
              Here we can write a additional notes for the client to get a better
              understanding of this invoice.
            </p>
          </div>
          <div class="thanks-msg text-center">Thanks for your Business</div>
        </div>
      </div>
      <div class="file-link">
        <button class="download_btn download-link">
          <i class="feather-download-cloud me-1"></i> <span>Download</span>
        </button>
        <a href="javascript:window.print()" class="print-link">
          <i class="feather-printer"></i> <span class="">Print</span>
        </a>
      </div>
    </div>
  </div>
</template>
